import { useState } from "react";
import { Table } from "react-bootstrap";
import { currencyFormat } from "../../../helpers/numericFields";
import { EditQuote } from "./EditQuote";
import * as colors from '../../../const/colors'
import styles from './QuoteDetails.module.css'
import { dateToDDMMYYYY, dateToM, dateToText, limitInMonths } from "../../../helpers/dates";

export const QuoteDetails = ({ quote }) => {
  const [editQuote, setEditQuote] = useState(false)
  const [lodgingRoomCategorySelected, setLodgingRoomCategorySelected] = useState({});

  return (
    <div style={{ marginTop: 20, marginBottom: 50, border: "1 solid gray", background: "white", padding: 20 }}>
      <div className={`${styles.title} ${styles.edit} text-center`} style={{ color: colors.title, marginLeft: 5 }}
        onClick={() => setEditQuote(true)}>HOTEL {quote.hotel}  {dateToText(quote.checkInDate)}</div>

      <div className={styles.tablesRow}>
        <div className={styles.quoteTableContainer}>
          <table className={styles.quoteTable} style={{ marginTop: 30 }}>
            <thead>
              <tr>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>Habitacion</div>
                </td>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>Publica</div>
                </td>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>{quote.nights} Noches</div>
                </td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Sencilla</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightSingle)}</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightSingle * quote.nights)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Doble</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightDouble)}</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightDouble * quote.nights)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Doble con menor</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightDouble + quote.costPerNightMinor)}</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat((quote.costPerNightDouble + quote.costPerNightMinor) * quote.nights)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Doble con 2 menores</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightDouble + (quote.costPerNightMinor * 2))}</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat((quote.costPerNightDouble + (quote.costPerNightMinor * 2)) * quote.nights)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Triple</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightTriple)}</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightTriple * quote.nights)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Triple con menor</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightTriple + quote.costPerNightMinor)}</div>
                </td>
                <td>
                  <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat((quote.costPerNightTriple + quote.costPerNightMinor) * quote.nights)}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={styles.quoteTableContainer}>
          <table className={styles.quoteTable}>
            <thead>
            <tr>
              <td colSpan={4}>
                <div className={`${styles.title} ${styles.segment} text-center`} style={{ color: colors.title }}>TARIFAS POR HABITACION POR NOCHE</div>
              </td>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Sencilla</div>
              </td>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Double</div>
              </td>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Triple</div>
              </td>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Menor 3 - 12</div>
              </td>
            </tr>
            <tr>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightSingle)}</div>
              </td>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightDouble)}</div>
              </td>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightTriple)}</div>
              </td>
              <td>
                <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.costPerNightMinor)}</div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.paymentsTableContainer} style={{ marginTop: 60 }}>
        <table className={`${styles.quoteTable} ${styles.paymentsTable}`}>
        <thead>
        <tr>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Habitacion</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Publica</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{quote.nights} Noches</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Anticipo</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Entra</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Sale</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Fecha limite</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Mes de cotizacion</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Mes limite</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Meses restantes</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Mensualidad por habitacion</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Mensualidad por persona</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>Comprobacion</div>
          </td>
          <td>
            <div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}></div>
          </td>
        </tr>
        </thead>
        <tbody>
          {quote.rooms.map((row) => (
            <tr key={row.room}>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{row.room}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(row.publicPrice)}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(row.roomTotal)}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(row.advance)}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{row.checkInDate}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{row.checkOutDate}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{row.paydayLimit}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment} text-center`} style={{ color: colors.title }}>{row.quoteMonth}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment} text-center`} style={{ color: colors.title }}>{row.paydayLimitMonth}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment} text-center`} style={{ color: colors.title }}>{row.remainingMonths}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(row.monthlyPerRoom)}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(row.monthlyPerPerson)}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(row.verification)}</div></td>
              <td><div className={`${styles.subTitle} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(row.difference)}</div></td>
            </tr>
          ))}
        </tbody>
        </table>
      </div>

      <div className={styles.quoteTableContainer}>
          <table className={styles.quoteTable} style={{ marginTop: 30 }}>
            <tbody>
              <tr>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>Anticipo del 10% de 25 habitaciones</div>
                </td>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.advancePayment25Rooms)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>Apartado de fecha</div>
                </td>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.dateReservationFee)}</div>
                </td>
              </tr>
              <tr>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>Anticipo</div>
                </td>
                <td>
                  <div className={`${styles.title} ${styles.segment}`} style={{ color: colors.title }}>{currencyFormat(quote.advancePayment)}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      {/* <EditQuote lodging={quote} isOpen={editQuote} setIsOpen={setEditQuote} /> */}
    </div>
  )
}
